import { Helmet } from 'react-helmet-async';
import CheckOrder from 'src/sections/checkOrder/view/kanban-list-view';

export default function CheckOrderList() {
  return (
    <>
      <Helmet>
        <title>Check Order</title>
      </Helmet>

      <CheckOrder />
    </>
  );
}
